import { useEffect, useMemo, useState } from 'react';
import { SELECT_FIELD_DEFAULT_VALUE } from '../../constants/settings';
import { useApplicationContext } from '../../contexts/ApplicationProvider';
import useLanguageActions from '../../hooks/APIHooks/users/useLanguageActions';
import { SelectData } from '../../types/common';
import SkillBadge from '../CommonComps/Badges/SkillBadge';
import AcademiaFormSelect from '../CommonComps/Inputs/AcademiaFormSelect';

const SelectSpokenLanguagesDiv = () => {
  // integration of react hooks here
  const [selectedLang, setSelectedLang] = useState<SelectData>(
    SELECT_FIELD_DEFAULT_VALUE
  );
  const [resetSelectField, setResetSelectField] = useState<boolean>(false);

  // integration of context hooks here
  const { selectedLanguages, setSelectedLanguages } = useApplicationContext();

  // integration of custom API hooks here
  const { getAddedLanguagesHandler } = useLanguageActions('addedLanguages');

  // setting selected language into the array here
  useEffect(() => {
    if (selectedLang.id !== -1) {
      setSelectedLanguages((state) => [
        ...state,
        {
          id: selectedLang.id,
          name: selectedLang.name,
          code: selectedLang.code as string,
        },
      ]);

      setSelectedLang(SELECT_FIELD_DEFAULT_VALUE);
    }
  }, [selectedLang, setSelectedLanguages]);

  const languageOptions = useMemo(() => {
    if (!getAddedLanguagesHandler.data?.data) return [];

    return getAddedLanguagesHandler.data.data
      .filter(
        (lang) =>
          !selectedLanguages.some(
            (selectedLang) => selectedLang.code === lang.code
          )
      )
      .map((lang) => ({
        id: lang.id,
        name: lang.name,
        code: lang.code,
      }));
  }, [getAddedLanguagesHandler.data, selectedLanguages]);

  // handler function to remove selected language from array declared here
  const removeSelectedLangHandler = (langCode: string) => {
    setSelectedLanguages((state) =>
      state.filter((lang) => lang.code !== langCode)
    );
  };

  // rendering spoken languages div component here
  return (
    <div>
      <AcademiaFormSelect
        name='spoken_language'
        label='Select a Spoken Language'
        options={languageOptions}
        defaultValue={selectedLang}
        setValueOnChange={(value) => {
          setSelectedLang(value);
          setResetSelectField(true);
        }}
        resetSelectField={resetSelectField}
        showSearchInput
        isRequired
      />

      {selectedLanguages.length ? (
        <div className='flex flex-wrap gap-2 my-4 border-2 border-legal-dark-blue border-dashed rounded-md p-4'>
          {selectedLanguages.map((selectedLang) => (
            <SkillBadge
              key={selectedLang.id}
              badgeLabel={selectedLang.name}
              color='#1ABC9C'
              onClickRemove={() => removeSelectedLangHandler(selectedLang.code)}
              isEditing
            />
          ))}
        </div>
      ) : null}
    </div>
  );
};

export default SelectSpokenLanguagesDiv;
